import { onBeforeUnmount, watch } from 'vue';
import { showModal } from '@phoenix/helpers/modal-helper';
import { debounce } from 'lodash-es';

export const useInactivity = (hasStarted, delay) => {
  const inactivityModalId = 'engraving-tool-inactivity-modal';
  const events = ['click', 'mousemove', 'touchstart', 'touchmove', 'keydown'];

  const debounced = debounce(() => {
    removeEventListeners();
    showModal(inactivityModalId);
  }, delay * 1000);

  const resetInactivityDelay = () => {
    if (delay && hasStarted.value) {
      debounced();
      addEventListeners();
    } else {
      debounced.cancel();
    }
  };

  const disableInactivity = () => {
    removeEventListeners();
    debounced.cancel();
  };

  const addEventListeners = () => {
    events.forEach((event) => {
      document.addEventListener(event, debounced);
    });
  };

  const removeEventListeners = () => {
    events.forEach((event) => {
      document.removeEventListener(event, debounced);
    });
  };

  watch(
    hasStarted,
    () => {
      resetInactivityDelay();
    },
    { immediate: true },
  );

  onBeforeUnmount(() => {
    removeEventListeners();
  });

  return { inactivityModalId, resetInactivityDelay, disableInactivity };
};
